import InsuredContent from './InsuredContent';
export default InsuredContent;
